import { ExclamationCircleOutlined } from '@ant-design/icons';
import React, { useCallback } from 'react';
import {
  HelperBoxContainer,
  IconWrapper,
  TextContainer,
  HelpText,
  HelpTextSmall,
  ContactLink,
} from './HelpBox.styles';

interface HelpBoxProps {
  title: string;
  description: string;
  linkText?: string;
  linkUrl?: string;
  icon?: string;
  isFml?: boolean;
  onLinkClick?: () => void;
}

export const HelpBox = ({
  title,
  description,
  linkText = 'clique aqui',
  linkUrl,
  onLinkClick,
}: HelpBoxProps) => {
  const handleLinkClick = useCallback(
    (event: React.MouseEvent<HTMLAnchorElement>) => {
      if (onLinkClick) {
        onLinkClick();
      }
    },
    [onLinkClick],
  );

  return (
    <HelperBoxContainer className="vert-helpbox-default-container">
      <IconWrapper className="vert-helpbox-default-icon">
        <ExclamationCircleOutlined
          color="#FFC107"
          className="vert-helpbox-default-icon"
        />
      </IconWrapper>
      <TextContainer className="vert-helpbox-default-content">
        <HelpText className="vert-helpbox-default-title">{title}</HelpText>
        <div>
          <HelpTextSmall dangerouslySetInnerHTML={{ __html: description }} />
          {linkUrl && (
            <ContactLink
              className="vert-helpbox-default-link"
              href={linkUrl}
              target="_blank"
              rel="noopener noreferrer"
              onClick={handleLinkClick}
            >
              {linkText}
            </ContactLink>
          )}
        </div>
      </TextContainer>
    </HelperBoxContainer>
  );
};
